import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { useT } from "../i18n";

const imagesMeta = [
    {
        src: "https://customer-assets.emergentagent.com/job_project-showcase-233/artifacts/3b1jryzy_WhatsApp%20Image%202026-05-09%20at%2017.11.46.jpeg",
        tag: "Detection",
        span: "md:col-span-7 md:row-span-2 aspect-[4/3]",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_project-showcase-233/artifacts/jk2jkxjk_WhatsApp%20Image%202026-05-09%20at%2017.52.13%20%281%29.jpeg",
        tag: "Mapping",
        span: "md:col-span-5 aspect-[1/1]",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_project-showcase-233/artifacts/zw7kxvqk_WhatsApp%20Image%202026-04-24%20at%2014.59.13.jpeg",
        tag: "Detection",
        span: "md:col-span-5 aspect-[4/5]",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_project-showcase-233/artifacts/xamjg6cl_picture%20%281%29.jpg",
        tag: "Hardware",
        span: "md:col-span-7 aspect-[4/3]",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_project-showcase-233/artifacts/rm0qksab_36e3fb25-1a2f-44cf-9bd0-4cdd16a085761.jpg",
        tag: "RGB · IR",
        span: "md:col-span-12 aspect-[16/8]",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_project-showcase-233/artifacts/2cwto4e6_WhatsApp%20Image%202026-05-08%20at%2016.54.55.jpeg",
        tag: "Hardware",
        span: "md:col-span-5 aspect-[4/5]",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_project-showcase-233/artifacts/q5jtibhj_WhatsApp%20Image%202026-05-11%20at%2017.06.57.jpeg",
        tag: "Simulation",
        span: "md:col-span-7 aspect-[4/3]",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_project-showcase-233/artifacts/3nkzyi6a_db3b75f3-c206-4618-9dd1-36984073.jpg",
        tag: "Simulation",
        span: "md:col-span-7 aspect-[4/3]",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_project-showcase-233/artifacts/6dgg7n37_36e3fb25-1a2f-44cf-9bd0-4cdd16a08576.jpg",
        tag: "RGB · IR",
        span: "md:col-span-5 aspect-[4/5]",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_project-showcase-233/artifacts/w855nlr9_WhatsApp%20Image%202026-05-12%20at%2012.38.30.jpeg",
        tag: "ArUco",
        span: "md:col-span-5 aspect-[4/5]",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_project-showcase-233/artifacts/s9zt7tcp_WhatsApp%20Image%202026-05-12%20at%2012.37.01.jpeg",
        tag: "ArUco",
        span: "md:col-span-7 aspect-[16/10]",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_project-showcase-233/artifacts/7vtallrz_WhatsApp%20Image%202026-05-12%20at%2012.37.40.jpeg",
        tag: "SLAM",
        span: "md:col-span-5 aspect-[4/5]",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_project-showcase-233/artifacts/rcp56fsi_WhatsApp%20Image%202026-05-09%20at%2017.11.46.jpeg",
        tag: "Detection",
        span: "md:col-span-7 aspect-[4/3]",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_project-showcase-233/artifacts/z3cmdzqk_WhatsApp%20Image%202026-05-11%20at%2001.34.08.jpeg",
        tag: "Pipeline",
        span: "md:col-span-12 aspect-[16/9]",
    },
];

export const Gallery = () => {
    const { t } = useT();
    const captions = t("gallery.captions");
    const [active, setActive] = useState(null);

    useEffect(() => {
        const onKey = (e) => {
            if (e.key === "Escape") setActive(null);
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, []);

    return (
        <main
            data-testid="gallery-page"
            className="bg-white text-[#0E1A2B]"
        >
            <section className="max-w-7xl mx-auto px-6 md:px-12 pt-16 md:pt-20 pb-12">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
                    <div className="md:col-span-8">
                        <p className="font-mono text-xs uppercase tracking-[0.22em] text-[#0033A0] mb-4">
                            {t("gallery.tag")}
                        </p>
                        <h1 className="font-display text-5xl md:text-7xl leading-[1.02] tracking-tight text-[#0033A0]">
                            {t("gallery.heading")}
                        </h1>
                    </div>
                    <div className="md:col-span-3 md:col-start-10">
                        <p className="text-sm leading-relaxed text-[#445268]">
                            {t("gallery.sub")}
                        </p>
                    </div>
                </div>
            </section>

            <section className="max-w-7xl mx-auto px-6 md:px-12 pb-20">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-5 auto-rows-min">
                    {imagesMeta.map((img, i) => (
                        <button
                            type="button"
                            key={i}
                            data-testid={`gallery-item-${i}`}
                            onClick={() => setActive({ ...img, caption: captions[i] })}
                            className={`group relative overflow-hidden border border-[#E5EAF2] bg-white text-left ${img.span} col-span-1`}
                        >
                            <img
                                src={img.src}
                                alt={captions[i]}
                                loading="lazy"
                                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#0E1A2B]/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                            <div className="absolute top-3 left-3 right-3 flex items-center justify-between font-mono text-[10px] uppercase tracking-[0.22em] text-white opacity-0 group-hover:opacity-100 transition-opacity">
                                <span className="bg-[#FFC72C] text-[#0033A0] px-2 py-1">
                                    {img.tag}
                                </span>
                                <span>
                                    {String(i + 1).padStart(2, "0")}/{imagesMeta.length}
                                </span>
                            </div>
                            <div className="absolute bottom-3 left-3 right-3 text-white text-sm opacity-0 group-hover:opacity-100 transition-opacity">
                                {captions[i]}
                            </div>
                        </button>
                    ))}
                </div>
            </section>

            {/* Lightbox */}
            {active && (
                <div
                    data-testid="gallery-lightbox"
                    role="dialog"
                    aria-modal="true"
                    onClick={() => setActive(null)}
                    className="fixed inset-0 z-[100] bg-[#0E1A2B]/95 backdrop-blur-sm flex items-center justify-center p-6 animate-fade-in"
                >
                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            setActive(null);
                        }}
                        data-testid="gallery-lightbox-close"
                        className="absolute top-6 right-6 text-white hover:text-[#FFC72C] transition-colors"
                        aria-label="Close"
                    >
                        <X size={28} strokeWidth={1.25} />
                    </button>
                    <figure
                        onClick={(e) => e.stopPropagation()}
                        className="max-w-5xl w-full"
                    >
                        <img
                            src={active.src}
                            alt={active.caption}
                            className="w-full max-h-[78vh] object-contain"
                        />
                        <figcaption className="mt-4 flex items-center justify-between font-mono text-xs uppercase tracking-[0.22em] text-white/70">
                            <span className="text-[#FFC72C]">{active.tag}</span>
                            <span>{active.caption}</span>
                        </figcaption>
                    </figure>
                </div>
            )}
        </main>
    );
};

export default Gallery;
